import { useState, useEffect } from "react";
import { HTTP } from "@/utils/Http";
import { AssetTypes } from "@/model/AssetTypes";
import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import MQ from '@/utils/MatchQueryUtils';
import { VacancyApplication, APOfferVacancyMeta } from '../../../model/VacancyApplicant.interface';
import VacancyOfferUtils from '../../../vacancy-applicant/utils/VacancyOfferUtils';

export function useVacancyContractData(activity: APActivity) {
  const [offer, setOffer] = useState<APOffer | null>(null);
  const [application, setApplication] = useState<VacancyApplication | null>(null);

  async function reload(silent = false) {
    const matchQuery = MQ.and(
      MQ.eq("data.linkedActivity.assetId", activity._id),
      MQ.in("data.status", VacancyOfferUtils.getOfferStatusForContractMQ())
    );

    const r = await HTTP.post({
      url: `/asset/list/${AssetTypes.ActivityRelated.Offer}`,
      bodyParams: {
        matchQuery,
      },
    });
    const offer = (r.data[0] as APOffer) || null;
    setOffer(offer);

    if (offer) {
      const offerMeta = offer.data.meta as APOfferVacancyMeta;

      const app = await HTTP.get({
        url: `/asset/${AssetTypes.ActivityRelated.VacancyApplication}/${offerMeta.applicationId}`,
      });
      setApplication(app as VacancyApplication);
    }
  }

  useEffect(() => {
    reload(true);
  }, []);

  return { offer, application, reload };
}
